import module from './login.module';
import './login.controller';
import './login.style.scss';

export default module.name;